import request from '@/utils/request'

// 发布举报
export function reportSave(data) {
  return request({
    url: '/py/report/save',
    method: 'post',
    data
  })
}

// 获取验证码
export function getVerifyCode(phone) {
  return request({
    url: '/api/report/verifyCode',
    method: 'get',
    params: {
      phone
    }
  })
}

// 获取加密公钥
export function getPublicKey() {
  return request({
    url: 'https://bxgz-api.gztvbxgz.cn/rumor/debunk/getPublicKey/bxgz_debunk',
    method: 'get'
  })
}

// 提交辟谣线索
export function reportInfoSave(data) {
  return request({
    url: 'https://bxgz-api.gztvbxgz.cn/rumor/debunk/add',
    method: 'post',
    data
  })
}
